import { Button, Col, Collapse, Icon, Modal, Progress, Select } from 'antd';
import React, { Component } from 'react';
import handleException from './../../services/handleException';
import { copyData } from './../../services/helper';
import { getImportDataMapping } from './../../utils/orders';
import UploadFile from './../upload-file';
import ImportPreview from './components/import-preview';
import ImportResult from './components/import-result';
import MapStep from './components/map-step';
import './styles.css';
import { alertError } from '../../services/dialog';
import lang from './../../languages/en'

const Panel = Collapse.Panel;
const Option = Select.Option;

class StepImportOrder extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            fileUpload: '',
            dataTypeMapping: null,
            stepCurrent: "1",
            stepCurrentActual: "1",
            listMapping: [],
            isLoading: false,
            percent: 1,
            listPreview: [],
            listDataValidate: [],
            resultImport: [],
            resultImportDetail: [],
            errorButtonImport: true,
            headerLineCount: 0,
            ErrorCountInputFile: 0,
            ImportFileIsDone: false,
            processImport: false
        }
        this.copyState = copyData(this.state)
        this.runProgress;
    }

    componentDidMount() {
        getImportDataMapping().then(res => {
            if (res.data.code === 10001) {
                let data = res.data.data;
                this.setState({
                    listMapping: data,
                    dataTypeMapping: data.length ? data[0].ID : null,
                })
            } else {
                handleException(res)
            }
        }).catch(err => {
            handleException(err)
        })
    }

    componentWillUnmount = () => {
        this.clearRunProgress()
    }

    clearRunProgress = () => {
        clearInterval(this.runProgress)
    }

    runningLoading = () => {
        this.runProgress = setInterval(() => {
            if (this.state.percent < 70) {
                this.setState({
                    percent: this.state.percent + Math.round(Math.random() * 15),
                })
            } else if (this.state.percent < 75) {
                this.setState({
                    percent: this.state.percent + 1,
                })
            } else {
                this.clearRunProgress()
            }
        }, 300)
    }

    onCancel = () => {
        let data = { ...this.copyState }
        this.clearRunProgress()
        delete data.dataTypeMapping
        delete data.listMapping
        this.setState({
            ...data
        })
    }

    selectTypeImport = (value) => {
        this.setState({
            dataTypeMapping: value
        })
    }

    onChangeUploadFile = (value, data) => {
        this.setState({
            fileUpload: value,
            listPreview: data.ImportingPreviews,
            listDataValidate: data.ImportingResultDetails,
            headerLineCount: data.HeaderLineCount,
            errorButtonImport: true,
            ImportFileIsDone: data.IsDone
        }, () => {
            let error = false
            if (!this.state.ImportFileIsDone) {
                alertError(lang.upload_more_10_error, lang.upload_more_10_error_line2)
            }
            this.state.listDataValidate.map((e, i) => {
                if (e.ResultType === 'Error') {
                    error = true
                }
                return;
            })
            this.setState({
                errorButtonImport: error
            })
        })
    }

    visibleStepImportOrder = (value) => {
        const { listMapping } = this.state
        if (listMapping && listMapping[0] && listMapping[0].ID) {
            this.setState({
                dataTypeMapping: listMapping[0].ID
            })
        }
        this.setState({
            visible: value,
            stepCurrent: "1",
            stepCurrentActual: "1",
            percent: 1
        })
    }

    renderListMapping = () => {
        return this.state.listMapping.map((e, i) => {
            return <Option key={i} value={e.ID}>{e.MappingName}</Option>
        })
    }

    renderNameMapping = () => {
        const { dataTypeMapping, listMapping } = this.state
        let nameMapping = ''
        listMapping.map((e, i) => {
            if (e.ID === dataTypeMapping) {
                nameMapping = e.MappingName
            }
            return;
        })
        return nameMapping
    }

    handleLoading = (value, typeHandle) => {
        if(typeHandle === 'importFile') {
            this.setState({
                isLoading: value,
                processImport: value
            })
        } else {
            this.setState({
                isLoading: value
            })
        }
    }

    loggedText = (percent) => {
        if (percent === 100) {
            return <Icon type="check" />;
        } else {
            if (this.state.stepCurrent === "1") {
                return percent > 90 ? "Validating" : "Uploading"
            } else {
                return "Importing"
            }
        }
    }

    handleUploadFile = (value) => {
        this.handleLoading(value)
        if (value) {
            this.runningLoading()
        } else {
            this.clearRunProgress()
        }
    }

    changeActionStep = (value) => {
        let stepCurrentActual = "1"
        let stepCurrent = "1"

        if (value === 'step2') {
            stepCurrentActual = "2"
            stepCurrent = "2"
        }
        if (value === 'step3') {
            stepCurrentActual = "3"
            stepCurrent = "3"
        }
        this.setState({
            stepCurrentActual,
            stepCurrent
        })
    }

    onChangeCollapse = (e) => {
        this.clearRunProgress()
        this.setState({
            stepCurrent: e === undefined ? undefined : e,
            percent: 1
        })
    }

    resultImport = (value) => {
        this.setState({
            resultImport: value.ImportResult,
            resultImportDetail: value.ImportResultDetailT,
            errorButtonImport: true
        })
    }

    dropHandler = (e) => {
        this.uploadFileRef.dropHandler(e)
    }

    dragOverHandler = (e) => {
        this.uploadFileRef.dragOverHandler(e)
    }

    render() {
        const { stepCurrentActual, stepCurrent } = this.state
        return (
            <div
                id='step-import-order'
                onDrop={stepCurrent === '1' ? this.dropHandler : null}
                onDragOver={stepCurrent === '1' ? this.dragOverHandler : null}
            >
                <Modal
                    title="ORDER DATA IMPORT"
                    visible={this.state.visible}
                    onCancel={this.onCancel}
                    maskClosable={false}
                    className={'modal-import-order ' + (this.state.isLoading ? 'component-cancel-import-order-file' : '')}
                    centered={true}
                    destroyOnClose={true}
                    footer={[
                        <Button
                            disabled={this.state.isLoading}
                            key="onCancel"
                            onClick={this.onCancel}>{stepCurrentActual === "3" ? 'Close' : 'Cancel'}
                        </Button>,
                    ]}
                >
                    <div className='content-step-import-order'>
                        <MapStep stepCurrentActual={stepCurrentActual} />
                        <Collapse
                            accordion
                            bordered={false}
                            activeKey={this.state.stepCurrent}
                            className={'collapse-import-order ' + ('current-active-step' + stepCurrentActual)}
                            onChange={(e) => this.onChangeCollapse(e)}
                        >
                            <Panel
                                header="Step 1"
                                key="1"
                            >
                                <Col span={12} className='col-select-type-import'>
                                    <Select
                                        value={this.renderNameMapping()}
                                        style={{ minWidth: '300px' }}
                                        onChange={this.selectTypeImport}
                                    >
                                        {this.renderListMapping()}
                                    </Select>
                                </Col>
                                <Col span={12} className='col-import-file-order'>
                                    <UploadFile
                                        onChangeUploadFile={this.onChangeUploadFile}
                                        mappingId={this.state.dataTypeMapping}
                                        handleUploadFile={this.handleUploadFile}
                                        changeActionStep={this.changeActionStep}
                                        ref={e => (this.uploadFileRef = e)}
                                    />
                                </Col>
                            </Panel>
                            <Panel
                                header="Step 2"
                                key="2"
                            >
                                <ImportPreview
                                    fileUpload={this.state.fileUpload}
                                    listPreview={this.state.listPreview}
                                    listDataValidate={this.state.listDataValidate}
                                    changeActionStep={this.changeActionStep}
                                    runningLoading={this.runningLoading}
                                    clearRunLoading={this.clearRunProgress}
                                    resultImport={this.resultImport}
                                    handleLoading={this.handleLoading}
                                    errorButtonImport={this.state.errorButtonImport}
                                    headerLineCount={this.state.headerLineCount}
                                />
                            </Panel>
                            <Panel
                                header="Step 3"
                                key="3"
                            >
                                <ImportResult
                                    resultImport={this.state.resultImport}
                                    resultImportDetail={this.state.resultImportDetail}
                                />
                            </Panel>
                        </Collapse>
                        {this.state.isLoading && (
                            <div id='loading-upload-file-order'>
                                <Progress
                                    className='loading-progress-upload-file'
                                    type="circle"
                                    percent={this.state.percent}
                                    format={this.loggedText}
                                />
                            </div>
                        )}
                    </div>
                </Modal>
            </div>
        );
    }
}

export default StepImportOrder;



// WEBPACK FOOTER //
// ./src/components/step-import-order/index.js